import React from 'react';
import { ViewCategoryState } from './viewCategoryState/ViewCategoryState';
import { ViewForm } from './components/ViewForm';
import { ModalWindows } from './components/ModalWindows';

export const ViewCategoryPageV2: React.FC = () => {
	return (
		<ViewCategoryState>
			<ViewForm />
			<ModalWindows />
		</ViewCategoryState>
	);
};
